import { render, staticRenderFns } from "./ImageBase.vue?vue&type=template&id=2bdd373f&scoped=true&lang=pug"
import script from "./ImageBase.vue?vue&type=script&lang=ts"
export * from "./ImageBase.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdd373f",
  null
  
)

export default component.exports